import { render, staticRenderFns } from "./SimilarProductsCarousel.sync.vue?vue&type=template&id=10211643&"
import script from "./SimilarProductsCarousel.sync.vue?vue&type=script&lang=js&"
export * from "./SimilarProductsCarousel.sync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports